var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskHasErrors)?_c('v-icon',{staticClass:"task-error",attrs:{"small":_vm.small,"large":_vm.large,"x-large":_vm.xLarge,"x-small":_vm.xSmall,"color":_vm.errcolor}},[_vm._v("mdi-alert-circle")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }